import api from '../store/axiosConfig';

export interface AIQuizRequest {
  topic: string;
  level: 'beginner' | 'intermediate' | 'advanced';
}

export const aiService = {
  async generateQuiz(data: AIQuizRequest) {
    const response = await api.post('/ai/generate-quiz', data);
    return response.data;
  }
};
